import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const AdminLogin = ({ onLogin, onBack }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Call the verify_admin_login function
      const { data, error } = await supabase.rpc('verify_admin_login', {
        p_username: credentials.username,
        p_password: credentials.password
      });

      if (error) throw error;

      // Check if login was successful
      if (data && data.length > 0 && data[0].success) {
        onLogin(true);
        localStorage.setItem('adminLoggedIn', 'true');
        localStorage.setItem('adminData', JSON.stringify({
          id: data[0].id,
          username: data[0].username,
          email: data[0].email
        }));
      } else {
        setError('Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        {onBack && (
          <button className="auth-back-btn" onClick={onBack}>
            ← Back to site
          </button>
        )}
        <div className="login-header">
          <h1>Admin Panel</h1>
          <p>Universal Sports Lab</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              placeholder="Enter username"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              placeholder="Enter password"
              required
            />
          </div>
          
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login to Admin Panel'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
